import { render, staticRenderFns } from "./ComparativeTableAI.vue?vue&type=template&id=6d705f42&scoped=true"
import script from "./ComparativeTableAI.vue?vue&type=script&lang=js"
export * from "./ComparativeTableAI.vue?vue&type=script&lang=js"
import style0 from "./ComparativeTableAI.vue?vue&type=style&index=0&id=6d705f42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d705f42",
  null
  
)

export default component.exports